/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
/******************************************
 *  Author : Suraj Sharma
 *  Created On : Tue Jan 05 2021
 *  File : PreAuthMap.jsx
 *******************************************/
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { preAuthPaths } from '../../config/constants/NavigationConstants';
import ActionCreators from '../../store/ActionCreators';
import { verifyTransaction, fetchTreeDetail } from '../../store/trees/ThunkActions';
import { CustomModal, TreeCounter, CustomNotification, CustomHeader, TreePopUp } from '../../components/commons';
import ClusterMap from '../../components/forest/clusterMap';
import { GeolocationUtil, useStateCallback } from '../../utils';

import styles from './PreAuthMap.module.css';

const mapStateToProps = (state) => ({
	auth: state.authReducer,
	trees: state.treesReducer
});

const mapDispatchTopProps = (dispatch) => bindActionCreators(ActionCreators, dispatch);

const connector = connect(mapStateToProps, mapDispatchTopProps);

const PreAuthMap = ({ ...props }) => {
	const modalAbsolutePositionClass = styles['modal-dialog-design'];
	const router = useRouter();
	// get the query parameters from the url
	const urlSelectedTreeCount_F = props.count;
	const urlApiSource_F = props.transaction_system;
	const urlTransactionId_F = props.transaction_id;
	const urlEmailId_F = props.email;
	const urlRestaurantName_F = props.restaurant_name;
	const { userExists } = props;

	const [state, setState] = useStateCallback({
		isFirstMapApiCall: true,
		isLoading: false,
		pos: {
			lat: -4.5111298721412965,
			lng: 35.52958761763869
		},
		error: false
	});

	const mapRef = React.useRef();

	const [modal, setModal] = useStateCallback({
		showModal: false,
		modalTitle: (<h4 className='tree-popup-title'>This could be your GiftTree…</h4>),
		modalBody: [],
		showNotification: false
	});

	const [isModalOnLeft, setIsModalOnLeft] = React.useState(false);

	// redux state and thunk method from redux store
	const {
		trees,
		fetchDynamicTrees, fetchTrees,
		chooseTree, unChooseTree,
		clearChoosenTrees,
		storeMeetingData
	} = props;

	const {
		isFetchingTrees,
		treeData,
		choosenTrees,
		urlSelectedTreeCount,
		urlTransactionId
	} = trees;
	const whiteListedZoomLevels = [3, 4, 5, 6, 12, 16, 20, 21];
	// const showMarkerOnZoomLevel = 17.74;
	const showMarkerOnZoomLevel = 15;

	React.useEffect(() => {
		initialize();
		return () => {
			setModal({
				...modal,
				showModal: false,
				showNotification: false
			});
		}
	}, []);

	const initialize = () => {
		// get current coordinates of user
		// this will be used to set default center for map
		/**
		 * TODO: commented below codes for static geolocation
		 */
		// getGeolocation()
		// .then((res)=>{
		// 	setState({
		// 		isLoading: false,
		// 		pos: {
		// 			lat: res.coords.latitude,
		// 			lng: res.coords.longitude
		// 		}
		// 	})
		// })
		// .catch((err)=>{
		// 	setState({
		// 		...state,
		// 		isLoading: false,
		// 		error: true
		// 	});
		// 	console.log(err)
		// });

		// store meeting Details to redux store for further processing
		if (urlApiSource_F && urlSelectedTreeCount_F && urlTransactionId_F) {
			// first verify whether the transaction is valid or not
			// before storing the details in localStorage
			verifyTransaction({ 
				transactionId: urlTransactionId_F, 
				treeCount: urlSelectedTreeCount_F, 
				email: urlEmailId_F, 
				transaction_system: urlApiSource_F 
			})
			.then((res) => {
				if (res.data.status === 200) {
					storeMeetingData({
						urlApiSource: urlApiSource_F,
						urlSelectedTreeCount: urlSelectedTreeCount_F,
						urlTransactionId: urlTransactionId_F,
						urlEmailId: urlEmailId_F || null,
						urlRestaurantName: urlRestaurantName_F,
						// urlRestaurantId: urlRestaurantId_F
					});
				} else {
					// if there's error in the transaction notify the user
					const modalBody = (
						<div>
							<span>This is an invalid transaction. You cannot use this to add trees in your forest!</span>
						</div>
					);
					setModal({
						...modal,
						modalTitle: 'Oops!',
						modalBody,
						showModal: true
					});
					setIsModalOnLeft(false);
				}
			})
			.catch((err) => {
				console.log(err);
			})
		}
		// if the urlApiSource is restaurant then we need to follow different
		// path
		else if (urlApiSource_F === 'restaurant') {
			storeMeetingData({
				urlApiSource: urlApiSource_F,
				urlRestaurantName: urlRestaurantName_F,
				urlRestaurantId: urlRestaurantId_F,
				urlSelectedTreeCount: 1,
				urlTransactionId: -1
			}).then(() => {
				// directly navigate to login
				// router.push(preAuthPaths.LOGIN);
			})
		}

		// console.log("urlSelectedTreeCount Tree Count-->", urlSelectedTreeCount);
		// console.log("choosenTrees Tree Count-->", choosenTrees);
		// console.log("Props Value-->", props);
		// console.log("Tree value-->", trees);
		// if (urlSelectedTreeCount === 0 || choosenTrees === 0) {
		// 	showZeroTreeCountModel();
		// }
	}

	const hideModal = () => {
		setModal({
			...modal,
			showModal: false,
			showNotification: false
		})
	}

	const getMapCoordinates = () => {
		// using the map object we are able to access getBounds method
		// but the catch being it wont give us NW and SE points
		// so we use basic replacement calculation 
		// i.e: if NW : (9, 10) and SE : (11, 12) 
		// then    NE : (9, 12) and SW : (11, 10)
		// this is not 100% accurate in cases where there is
		// orientation change on map		
		const map = mapRef.current.map_;
		if (map !== null) {
			const { zoom } = map;
			const ne = map.getBounds().getNorthEast();
			const sw = map.getBounds().getSouthWest();
			const neLat = ne.lat();
			const neLng = ne.lng();
			const seLat = sw.lat();
			const seLng = sw.lng();
			const nw = {
				lat: neLat,
				lng: seLng
			}
			const se = {
				lat: seLat,
				lng: neLng
			}
			return {
				nw,
				se,
				zoom: zoom / 1.83
				// zoom: (zoom / 1.83 - 1.5) < 1 ? 1 : (zoom / 1.83 - 1.5)
			}
		}
		return null;
	}

	const onMapReady = (map, maps) => {
		/**
		 * If the user has already added some trees then
		 * zoom on those trees
		 */
		if (Object.keys(choosenTrees).length > 0) {
			// select first marker from the Object list
			const marker = Object.entries(choosenTrees)[0][1];
			const { lat, lng } = marker;
			// console.log(lat, lng);
			// map.setCenter(new window.google.maps.LatLng(lat, lng));
			map.setZoom(18);
			panToCluster(marker);
			try {
				/**
				 * This is the logic for the modal to pop up containing information about 
				 * selected marker
				 * NOTE: The modal containing the marker info should only popup
				 * if the user has claimable trees or when the user source is restaurant
				 */

				// if there already exists a modal that most probably is from notification
				// then dont show marker detail
				onClickMarker(false, marker);
			} catch (error) {
				console.log(marker);
				console.log(error);
			}
		} else {
			/**
			 * Changing the zoom level from 6 to 4 for a fix
			 * The trees were not visible in DEV with zoom level 6
			*/
			map.setZoom(6);
			fetchUnclaimedTrees();
		}
	}

	const fetchUnclaimedTrees = () => {
		const { isFirstMapApiCall } = state;
		const getMapData = getMapCoordinates();
		if (getMapData != null) {
			const { nw, se, zoom } = getMapData;
			// when map changes this function will be called
			// which in turn calls thunkAction for fetchTrees
			/**
			 * Math.min(Math.max(value, min), max) is clamping function which
			 * will make sure our points are betweem the min and max value
			 */
			const postBodyData = {
				type: 'unclaimed',
				precision: zoom,
				top_left_point: {
					lat: Math.min(Math.max(nw.lat, -90), 90),
					lon: Math.min(Math.max(nw.lng, -180), 180),
				},
				bottom_right_point: {
					lat: Math.min(Math.max(se.lat, -90), 90),
					lon: Math.min(Math.max(se.lng, -180), 180),
				},
			};

			// if there already is a api call happening
			// dont do unless it is over

			if (!isFetchingTrees) {
				/**
				 * We have two types of fetch apis which can be called.
				 * One is when first api call happens which calls dynmaic fetch trees api
				 * and rest on is normal api calls
				 */

				/**
				 * NOTE:In develop branch fetchDynamicTrees will be replaced by fetch trees
				 */

				 const thunkActionToBeCalled = isFirstMapApiCall && 
				 Object.keys(choosenTrees).length === 0 ? fetchTrees : fetchTrees;

				thunkActionToBeCalled(postBodyData)
				.then((res)=>{
					setState({
						...state,
						isFirstMapApiCall: false,
					},()=>{
						/**
						 * NOTE: Comment below lines in develop branch
						 */
						// if(isFirstMapApiCall && Object.keys(choosenTrees).length === 0){
						// 	if(res && res.length>0){
						// 		panToCluster(res[0]);
						// 	}	
						// }
					});
				}).catch((e)=>{console.log(e);});
			}
		}
	}

	const panToCluster = (marker) => {
		if (marker.lat === undefined && marker.lng === undefined) {
			return;
		}
		// if its cluster then the map should pan to that coordinates
		const bounds = new window.google.maps.LatLngBounds();
		bounds.extend({
			lat: Number(marker.lat),
			lng: Number(marker.lng),
		});
		/**
		 * check the zoom level of map and accordingly select
		 * which zoom level to be set
		 */
		const sizeOfWhiteListedLevels = whiteListedZoomLevels.length;
		const currentZoomLevel = mapRef.current.map_.zoom;

		const closest = whiteListedZoomLevels.reduce((prev, curr) =>
			Math.abs(curr - currentZoomLevel) < Math.abs(prev - currentZoomLevel) ? curr : prev,
		);

		const closestIndex = whiteListedZoomLevels.indexOf(closest);
		// check if the closestIndex is not last
		if (typeof whiteListedZoomLevels[closestIndex + 1] !== 'undefined' && closestIndex < sizeOfWhiteListedLevels) {
			// there is one more zoom level we can zoom into
			try {
				mapRef.current.map_.fitBounds(bounds);
				mapRef.current.map_.setZoom(whiteListedZoomLevels[closestIndex + 1]);
			} catch (error) {
				console.log(error);
			}
		} else {
			/**
			 * Some error occurred like when user clicks on marker so fast we arent able to 
			 * propagate that to maps mapRef.current.map_.setZoom(?) seems to error.
			 * We will set a step back and set current zoom level to whiteListedZoomLevels[closestIndex]
			 */
			mapRef.current.map_.setZoom(whiteListedZoomLevels[closestIndex - 1]);
			console.warn('Errored out!, current zoom level : ', currentZoomLevel, ' closest index : ', closestIndex)

		}
	}

	const addTreeToForest = (choosenTree, isSelected) => {
		/**
		 * each time a tree is added to forest we check
		 * if the total tree count has been acheived by adding
		 */
		// check if selected		
		if (!isSelected) {
			chooseTree({ choosenTree })
				.then((res) => {
					const totalTreesAdded = Object.keys(choosenTrees).length + 1; // + 1 bcoz previous length + new tree
					// if we have added all trees required
					// then notify user accordingly
					if (Number(totalTreesAdded) === Number(urlSelectedTreeCount)) {
						try {
							// show the Notification
							if (userExists) {
								console.log('logging in');
								router.push(preAuthPaths.LOGIN)
							} else {
								setModal({
									...modal,
									showModal: false,
									showNotification: true,
								});
							}
						} catch (error) {
							console.log('error', window.$);
						}
					} else {
						// hide the modal anyways
						setModal({
							...modal,
							showModal: false,
						})
					}
				});
		} else {
			setModal({
				...modal,
				showModal: false
			})
		}
	}

	const onUnChooseTree = (token) => {
		unChooseTree({ unChoosenTree: token });
		setModal({
			...modal,
			showModal: false
		});
	}

	const createModalBodyFromMarkerObject = (marker) => {
		const modalBody = [];
		const { image_url, location_point, region, token, tree_captured_at, species, farmer_first_name,farmer_last_name ,farmer_image_url, lat, lng } = marker;
		// check if token is saved
		const isSelected = token in choosenTrees;
		const date = new Date(tree_captured_at);
		const addData = {};
		addData[token] = {
			...marker
		};
		let buttonAction = () => addTreeToForest(addData, isSelected);
		let buttonText = '';
		if (!isSelected) {
			buttonText = 'Add Tree To Forest';
		} else if (isSelected) {
			buttonText = 'Tree Already Added';
		}

		// The all the trees required has already been added and no more 
		// trees available then Continue to Login
		if (Object.keys(choosenTrees).length === Number(urlSelectedTreeCount)) {
			buttonText = 'Continue to Log in';
			buttonAction = () => {
				setModal({
					...modal,
					showModal: false
				})
				router.push(preAuthPaths.SIGNUP);
			};
		}

		modalBody.push(
			<div className={styles.treeDetailBody} key={1}>
				<TreePopUp
					image_url={image_url}
					species={species}
					farmer_first_name={farmer_first_name}
					farmer_last_name={farmer_last_name}
					farmer_image_url={farmer_image_url}
					lat={lat}
					lng={lng}
				></TreePopUp>
				{
					!isSelected && (
						<button type="button" className={styles.addTreeButton} onClick={buttonAction}>
							{buttonText}
						</button>
					)
				}
				{
					isSelected && (
						<div
							key={1}
							className={styles.buttonContainer}
							style={{ justifyContent: 'center' }}
						>
							<button
								type="button"
								className={styles.addTreeButton}
								onClick={() => onUnChooseTree(token)}
								style={{ backgroundColor: '#4a4a4a' }}
							>
								Deselect Tree
					</button>
						</div>
					)
				}
			</div>
		);
		setModal({
			...modal,
			modalTitle: (<h4 className='tree-popup-title'>This could be your GiftTree…</h4>),
			modalBody,
			showModal: true
		});

		setIsModalOnLeft(true);
	}

	const onClickMarker = (isCluster, marker) => {
		if (!isCluster) {
			/**
			 * createModalBodyFromMarkerObject creates state for new marker data
			 * to be displayed in modal.
			 * To actually display the modal we have to toggle the modal class
			 */
			const { token } = marker;

			fetchTreeDetail(token)
				.then(res => createModalBodyFromMarkerObject(res));
			return;
		}

		// pan map to given marker location
		panToCluster(marker);
	};

	/**
	 * BELOW THIS LINE IS RENDER METHOD FOR 
	 * PREAUTHMAP
	 */

	const remainingTreesToAdd = urlSelectedTreeCount - Object.keys(choosenTrees).length;
	const counterMessage = remainingTreesToAdd !== 0
		? `Choose any ${remainingTreesToAdd} tree(s)`
		: `Add ${urlSelectedTreeCount} tree(s) to your forest`;

	const notShowCounter = Object.keys(choosenTrees).length > 1 && urlTransactionId === null;

	let shouldSignup;
	let shouldLogin;
	let notificationMessage;

	if (urlEmailId_F) {
		// if url has emailId
		if (userExists) {
			shouldSignup = false;
			shouldLogin = true;
			notificationMessage = "Please log in to choose your tree(s).";
		} else {
			shouldSignup = true;
			shouldLogin = false;
			notificationMessage = "Please signup to choose your tree(s)."
		}
	} else {
		// we dont know if user exists or not
		shouldSignup = true;
		shouldLogin = true;
		notificationMessage = 'Please log in/signup to choose your tree(s).';
	}


	return (
		<div style={ {height: '100vh', width: '100%', position: 'absolute', top: 0} } className="forest-map">
			<>
				{/* <CustomHeader /> */}
				{
					!state.isLoading && (
						<>
							{
								!notShowCounter && (
									<TreeCounter
										message={counterMessage}
										enabledBtn={remainingTreesToAdd === 0}
										onClick={() => router.push(preAuthPaths.SIGNUP)}
									/>
								)
							}
							<ClusterMap
								{...props}
								mapRef={mapRef}
								centerCoordinate={state.pos}
								onMapReady={onMapReady}
								onChange={fetchUnclaimedTrees}
								markerCoordinates={treeData}
								defaultZoom={whiteListedZoomLevels[0]}
								onClickMarker={onClickMarker}
								showMarkerOnZoomLevel={showMarkerOnZoomLevel}
								isFetchingTrees={isFetchingTrees}
								choosenTrees={choosenTrees}
							/>
						</>
					)
				}
				<CustomModal
					show={modal.showModal}
					modalTitle={modal.modalTitle}
					showModalFooter={false}
					className={isModalOnLeft ? modalAbsolutePositionClass : ''}
					onClose={hideModal}
				>
					{modal.modalBody}
				</CustomModal>
				<CustomNotification
					show={modal.showNotification}
					notificationTitle='Notice'
					notificationMessage={notificationMessage}
					enableButtonOne={shouldSignup}
					enableButtonTwo={shouldLogin}
					buttonActionOne={() => router.push(preAuthPaths.SIGNUP)}
					buttonActionTwo={() => router.push(preAuthPaths.LOGIN)}
					buttonTextOne={'Signup'}
					buttonTextTwo={'Log in'}
					onClose={hideModal}
				/>
			</>
		</div>
	);
};

PreAuthMap.defaultProps = {
	auth: {},
	trees: {},
	fetchTrees: null,
	fetchDynamicTrees: null,
	chooseTree: null,
	unChooseTree: null,
	storeMeetingData: null,
	location: {},
	verifyTransaction: null
}

PreAuthMap.propTypes = {
	auth: PropTypes.instanceOf(Object),
	trees: PropTypes.instanceOf(Object),
	fetchTrees: PropTypes.func,
	fetchDynamicTrees: PropTypes.func,
	chooseTree: PropTypes.func,
	unChooseTree: PropTypes.func,
	storeMeetingData: PropTypes.func,
	location: PropTypes.instanceOf(Object),
	verifyTransaction: PropTypes.func
}

export default connector(PreAuthMap);
